require('dotenv').config()

export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-11-14'

export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '160ctq6w'

// This is the token used to authenticate with the Sanity API
// It should only be used on the server side
export const token = process.env.SANITY_API_TOKEN

export default {
  apiVersion,
  dataset,
  projectId,
  token,
  useCdn: false,
}
